import type { ProfileResource } from "@medplum/core";

type SessionIdsInput = {
  profile: ProfileResource | undefined;
  /**
   * The project the app resolved from its own context.
   */
  contextProjectId: string | undefined;
  /**
   * The project the Medplum client holds for the signed-in user.
   */
  clientProjectId: string | undefined;
};

/**
 * The ids every page fetches with. The project comes from the app's own
 * context and falls back to the client's, which knows it before the context
 * has loaded. The practitioner is set only for a Practitioner profile: any
 * other profile (a patient, a related person) has an id that is not a
 * practitioner's, and using it would fetch another resource's schedule.
 */
export const resolveSessionIds = ({
  profile,
  contextProjectId,
  clientProjectId,
}: SessionIdsInput) => ({
  projectId: contextProjectId ?? clientProjectId ?? null,
  practitionerId:
    profile?.resourceType === "Practitioner" ? (profile.id ?? null) : null,
});
